{
	"name": "@oidfed/cli",
	"version": "1.0.0",
	"description": "Command-line interface for inspecting, validating, and debugging OpenID Federation deployments — resolve trust chains, decode entity statements, verify signatures, and more.",
	"license": "Apache-2.0",
	"author": "Justin Dah-kenangnon <dah.kenangnon@gmail.com>",
	"repository": {
		"type": "git",
		"url": "https://github.com/Dahkenangnon/oidfed.git",
		"directory": "tools/cli"
	},
	"homepage": "https://github.com/Dahkenangnon/oidfed/tree/main/tools/cli#readme",
	"bugs": {
		"url": "https://github.com/Dahkenangnon/oidfed/issues"
	},
	"keywords": [
		"openid-federation",
		"openid federation",
		"trust chain",
		"trust-chain",
		"entity-statement",
		"oauth2",
		"oidc",
		"federation",
		"eidas",
		"edugain",
		"federated-identity",
		"trust-mark",
		"subordinate-statement",
		"trust-anchor",
		"cli"
	],
	"type": "module",
	"main": "./dist/index.cjs",
	"module": "./dist/index.js",
	"types": "./dist/index.d.ts",
	"bin": {
		"oidfed": "./dist/bin.js",
		"openidfed": "./dist/bin.js"
	},
	"exports": {
		".": {
			"types": "./dist/index.d.ts",
			"import": "./dist/index.js",
			"require": "./dist/index.cjs"
		}
	},
	"files": [
		"dist",
		"LICENSE",
		"NOTICE"
	],
	"sideEffects": false,
	"engines": {
		"node": ">=22.12.0"
	},
	"publishConfig": {
		"access": "public"
	},
	"scripts": {
		"build": "tsup",
		"typecheck": "tsc --noEmit",
		"test": "vitest run",
		"clean": "rm -rf dist"
	},
	"dependencies": {
		"@oidfed/core": "workspace:^",
		"commander": "15.0.0",
		"yaml": "2.9.0",
		"chalk": "5.6.2",
		"zod": "4.4.3"
	}
}
